//あいうえお
<template>


  <div class="w-full">

    <p class="mb-20 text-center">{{contact.message}}</p>

    <div class="w-full text-center">
      <button type="button" @click="prev" class="btn w-full sm:w-auto mb-10 sm:mb-0">戻る</button>
    </div>

  </div>
</template>

<script>
export default {
  props: [
   'contact'
  ],

  methods: {
    prev(){
      this.$emit('step', 1);
    },
  }
}
</script>

<style>

</style>
